<template>
  <section v-if="!loginType">

    <slot name="header">
      <figure class="text-center mb-base">
        <img src="./img/logo-huishoubao.png">
      </figure>
    </slot>

    <h-input type="tel" v-model="tel" class="mb-base login-input" :placeholder="$t('login.tel')" pretabindex="-1">
      <template slot="prepend"><slot name="telpre"></slot></template>
    </h-input>
    <h-input type="text" v-model="smsCode" class="mb-base login-input sms-code" :placeholder="$t('login.code')">
      <!-- <template slot="prepend">code</template> -->
    </h-input><!--
    --><h-button class="login-btn sms-btn" type="primary" @click="getSMSCode" :disabled="submitting || !isMobilePhone || isCounting">
    <template v-if="!isCounting">
      {{ $t('login.getcode') }}
    </template>
    <template v-else>
    {{ count }}
    </template>
    </h-button>
    <check-box class="mb-base" v-model="checked">{{ $t('login.autoLogin') }}</check-box>
    <h-button class="mb-base login-btn" type="primary" size="large" :disabled="submitting || !isMobilePhone || !smsCode" @click="doLogin">{{$t('login.login')}}</h-button>
    <p class="text-muted">{{$t('login.tips')}}</p>
    <!-- <nav>
      <ul>
        <li @click="wxLogin">微信登录</li>
        <li @click="wxLogin">github</li>
        <li @click="vivoLogin">vivo登录</li>
      </ul>
    </nav> -->
    <popup v-model="popupVis">
      <h4>请输入图形验证码</h4>
      <h-input type="code" name="" v-model="limitCode">
        <template slot="append">
          <img :src="validCodeSrc" @click="changeImg">
        </template>
      </h-input>

      <h-button @click="getSMSCode" type="primary" :disabled="!limitCode" size="large">验证</h-button>
    </popup>
  </section>

  <section v-else class="text-center auth-login">
    <spinner :show="true"></spinner> <br>
    <span v-if="!token">登录中。。。</span>
    <span v-else>登录成功！</span>
  </section>
</template>

<style type="text/css" scoped>
.auth-login {
  padding-top: 200px;
  color: #fff;
  text-shadow: black 0.1em 0.1em 0.2em
}
.login-input /deep/ .el-input__inner, .login-btn {
  height: 50px;
  vertical-align: top;
}

.sms-code {
  width: 56%;
  margin-right: 4%;
}

.sms-btn {
  width: 40%;
}
</style>

<script type="text/javascript">
import { getCode, login, getUserInfo } from '@/apis/base';
import { Toast, Popup } from 'mint-ui';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { CheckBox, Button as hButton, Input as hInput, Spinner } from 'hsb_recycle_components';
import parse from 'url-parse';

const auth2Urls = {
  wx: 'https://www.huishoubao.com/common/login/wxLogin',
  vivo: 'https://www.huishoubao.com/common/login/vivoLogin'
};
const SEC = 30;
const checkedDay = 30;
const unCheckedDay = 15;

export default {
  data () {
    return {
      tel: '',
      smsCode: '',
      limitCode: '',
      valid_days: 15,
      count: SEC,
      submitting: false,
      popupVis: false,
      validCodeSrc: '',
      checked: true
    };
  },
  components: {
    Spinner,
    Popup,
    CheckBox,
    hButton,
    hInput
  },
  props: {
    authUrl: String,
    authPrams: Object
  },
  computed: {
    redirect () {
      return this.$route.query.redirect;
    },
    auth2CallBack () {
      return window.encodeURIComponent(window.location.href);
    },
    // 只用于第三方登录回调
    token () {
      return this.$route.query.token;
    },
    loginType () {
      return this.$store.state.config.loginType;
    },
    auth2LoginUrl () {
      return this.$store.state.config.auth2LoginUrl;
    },
    isCounting () {
      return this.count !== SEC;
    },
    isMobilePhone () {
      // return isMobilePhone(this.tel, getLanguage());
      return isMobilePhone(this.tel, 'zh-CN') || isMobilePhone(this.tel, 'ru-RU');
    },
    expires () {
      return this.checked ? checkedDay : unCheckedDay;
    }
  },
  methods: {
    changeImg () {
      this.validCodeSrc = `${this.$store.state.apiHost}/common/user/getCaptch/?_t=${new Date().getTime()}&pid=10000`;
    },
    startCount () {
      this.count--;
      setTimeout(() => {
        if (this.count === 0) {
          this.count = SEC;
          return;
        }
        this.startCount();
      }, 1000);
    },
    async getSMSCode () {
      this.submitting = true;
      try {
        const ret = await getCode(this.tel, this.limitCode);
        if (!ret || Number(ret._errCode) !== 0) {
          // if (ret._errCode === 200) {
          //   this.popupVis = true;
          //   this.changeImg();
          //   return;
          // }
          Toast(ret._errStr);
          return;
        }
        this.startCount();
        Toast(this.$t('login.success'));
      } catch (err) {

      } finally {
        this.submitting = false;
      }
    },
    loginAfter (token, userInfo) {
      if (userInfo) {
        this.$store.commit('user/setUserInfo', {
          tel: userInfo.tel,
          openid: userInfo.openid
          // name: 'tmq'
        });
      }
      this.$store.commit('user/setToken', token, this.expires);
      //  针对oppo登录系统 pc下登录后退出异常问题
      if (this.loginType === 'oppo' && window !== window.top) {
        const toUrl = this.$router.resolve(this.redirect, this.$router.currentRoute);
        const oppocallback = `${window.location.origin}${toUrl.href}`;
        window.top.location = `${this.$store.state.config.oppoURL.oppoHost}?redirect=${window.encodeURIComponent(oppocallback)}`;
        return;
      }
      this.$router.replace(this.redirect);
    },
    async doLogin () {
      const loginRet = await login(this.tel, this.smsCode, this.expires);
      if (!loginRet || Number(loginRet._errCode) !== 0 || !loginRet._data) {
        Toast(loginRet._errStr);
        return;
      }
      this.loginAfter(loginRet._data.token, loginRet._data);
    },
    wxLogin () {
      window.location.replace(`${auth2Urls.wx}?redirect_uri=${this.auth2CallBack}`);
    },
    vivoLogin () {
      window.location.replace(`${auth2Urls.vivo}?redirect_uri=${this.auth2CallBack}`);
    },
    autoAutoLogin () {
      const loginUrl = `${this.auth2LoginUrl}?redirectUri=${this.auth2CallBack}&platform=${this.$store.state.config.platform}&pid=${this.$store.state.pid}&oauthSite=${this.loginType}`;
      const urlObj = parse(loginUrl, true);
      if (this.authPrams) {
        Object.keys(this.authPrams).forEach(key => {
          urlObj.query[key] = this.authPrams[key];
        });
      }
      window.location.replace(urlObj.toString());
    },
    getUserInfo (ntoken) {
      return getUserInfo(ntoken).then(res => {
        if (!res || +res._errCode !== 0 || !res._data) {
          return;
        }
        return res._data;
      });
    }
  },

  created () {
    if (this.token) {
      this.getUserInfo(this.token).then(userInfo => {
        this.loginAfter(this.token, userInfo);
      });
    }
  },
  mounted () {
    if (!this.token && this.loginType) {
      this.autoAutoLogin();
    }
  }
};
</script>
